module.exports = __webpack_public_path__ + "static/img/wenlv.4b953ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/wenlv.png
// module id = mm1w
// module chunks = 1